<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="os-tabs-w" v-if="current.id">
              <div class="os-tabs-controls os-tabs-complex text-right">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <span aria-expanded="true" class="nav-link active">
                      <span style="font-size: 20px; font-weight: bold; color: #4f752c">Viaje Para Reparto # {{
                        current.numero }}</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="element-box mb-0">
              <router-link class="btn btn-md" :to="{ name: 'wms-asignar-pedido-reparto', params: {} }">
                <span class="font-weight-bold">
                  <i class="fas fa-chevron-circle-left"></i>&nbsp; Volver atrás
                </span>
              </router-link>
              &nbsp;
              <div v-if="current.estado == '9'" class="badge badge-danger">Anulado</div>
              <div v-if="current.estado == 'C'" class="badge badge-dark">Finalizado</div>
              <div v-if="current.estado == 'A'" class="badge badge-success">
                En proceso de carga
              </div>
              <h5 v-if="!current.pk" class="form-header">
                <div class="st-meta float-right">
                  <div class="element-actions">
                    <div class="btn-group">
                      <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary btn-md dropdown-toggle"
                        data-toggle="dropdown" type="button">
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button class="dropdown-item" @click="anularViajeReparto()">
                          <i class="fas fa-times-circle"></i>
                          Anular Transacción
                        </button>
                        <button class="dropdown-item" @click="finalizarViajeReparto()">
                          <i class="fas fa-door-closed"></i>
                          Finalizar transacción
                        </button>
                        <button class="dropdown-item" @click="abrirTransaccion()">
                          <i class="fas fa-door-open"></i>
                          Abrir transacción
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </h5>
              <div class="col-12 row">
                <div class="col-md-3">
                  <TiendaSelectComponent _class="form-control form-control-sm" :disabled="current.estado != 'A'"
                    :current="current" />
                  <br />
                </div>
                <div class="col-md-3">
                  <UsuariosSelectComponent titulo="Encargado" :current="current" :disabled="true" />
                </div>
                <div class="col-sm-3">
                  <PilotoSelectComponent object="piloto" :current="current" />
                </div>
                <div class="col-sm-3">
                  <ActivoFijoSelectComponent titulo="Vehiculo" object="vehiculo" :current="current" />
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Descripción</label>
                    <textarea v-model="current.comentarios" autofocus="autofocus" class="form-control"
                      placeholder="Descripción" type="text" :disabled="current.estado != 'A'"></textarea>
                    <small v-if="current.errors && current.errors.comentarios" class="form-text text-danger">{{
                      current.errors.comentarios[0] }}</small>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Fecha creación</label>
                    <input v-model="current.fecha_creacion" autofocus="autofocus" class="form-control"
                      placeholder="Fecha creación" type="text" :disabled="true" />
                    <small v-if="current.errors && current.errors.fecha_creacion" class="form-text text-danger">{{
                      current.errors.fecha_creacion[0] }}</small>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Fecha salida</label>
                    <input v-model="current.fecha_salida" autofocus="autofocus" class="form-control"
                      placeholder="Fecha salida" type="text" :disabled="true" />
                    <small v-if="current.errors && current.errors.fecha_salida" class="form-text text-danger">{{
                      current.errors.fecha_salida[0] }}</small>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Fecha retorno</label>
                    <input v-model="current.fecha_retorno" autofocus="autofocus" class="form-control"
                      placeholder="Fecha retorno" type="text" :disabled="true" />
                    <small v-if="current.errors && current.errors.fecha_retorno" class="form-text text-danger">{{
                      current.errors.fecha_retorno[0] }}</small>
                  </div>
                </div>
                <div class="col-12 form-buttons-w">
                  <button @click="guardar()" class="btn btn-success">
                    Guardar &nbsp; <i class="fas fa-save"></i>
                  </button>
                  &nbsp;
                  <div class="btn-group">
                    <button :disabled="!(current.estado == 'C')" aria-expanded="false" aria-haspopup="true"
                      class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" type="button">
                      <i class="fa fa-print"></i>
                      Impresiones
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                      <a class="dropdown-item" @click="imprimir(current)">Reporte general <i class="fas fa-print"></i></a>
                      <a class="dropdown-item" @click="imprimirDetalle(current)">Reporte detallado <i
                          class="fas fa-print"></i></a>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <PedidoRepartoProjectTableComponent @refresh="refreshCurrent()" :current="current" />
            </div>
            <div style="z-index: -1" v-if="current.estado == 'A'">
              <div class="floated-chat-btn" @click="abrirModalAsignarPedido()">
                <i class="fas fa-window-restore"></i>&nbsp;Asignar pedido
              </div>
            </div>
            <div class="modal fade" id="modalAsignarPedido" tabindex="1" role="dialog"
              aria-labelledby="modalAsignarPedido" aria-hidden="true" style="z-index: 99999">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="modalAsignarPedido">
                      Escanear pedido
                      <i class="fas fa-barcode"></i>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="col-12">
                      <label>Barra</label>
                      <input type="text" class="form-control" v-model="currenDetalle.barra" />
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                      <i class="fas fa-chevron-circle-down"></i> Cerrar
                    </button>
                    <button @click="asignarPedidoViaje()" type="button" class="btn btn-primary">
                      <i class="fas fa-check"></i> Aceptar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import PedidoRepartoProjectTableComponent from "@/components/wms/asignar_pedido_reparto/PedidoRepartoProjectTableComponent";
import DynamicService from "@/services/commons/DynamicService";
import PilotoSelectComponent from "@/components/commons/PilotoSelectComponent";
import ActivoFijoSelectComponent from "@/components/commons/ActivoFijoSelectComponent";

export default {
  components: {
    TiendaSelectComponent,
    UsuariosSelectComponent,
    PedidoRepartoProjectTableComponent,
    PilotoSelectComponent,
    ActivoFijoSelectComponent,
  },
  data() {
    return {
      currenDetalle: {
        barra: "",
      },
      current: {},
    };
  },
  mounted() {
    let self = this;
    DynamicService.getById("cat", "viajes-reparto", self.$route.params.id).then(
      (response) => {
        self.current = response.data;
        self.current.usuario = self.current.encargado_obj;
        self.current.fecha_creacion = moment(self.current.fecha_creacion).format(
          "DD/MM/YYYY"
        );
        if (self.current.vehiculo_obj) {
          self.current.vehiculo = self.current.vehiculo_obj;
        }
        if (self.current.fecha_retorno) {
          self.current.fecha_retorno = moment(self.current.fecha_retorno).format(
            "DD/MM/YYYY"
          );
        }
        if (self.current.fecha_salida) {
          self.current.fecha_salida = moment(self.current.fecha_salida).format(
            "DD/MM/YYYY"
          );
        }
        if (self.current.piloto_obj) {
          self.current.piloto = self.current.piloto_obj;
        }
      }
    );
  },
  methods: {
    abrirTransaccion() {
      let self = this;
      Notifications.alert.confirm(
        "abrir viaje reparto",
        "¿Seguro(a)?",
        "Si",
        function () {
          DynamicService.postAction(
            "cat",
            "viajes-reparto",
            self.current.id,
            "abrir_viaje_reparto"
          )
            .then(
              self.refreshCurrent(),
              Notifications.alert.success("abrir Viaje Reparto", "Realizado Exitosamente")
            )
            .catch((errors) => {
              Notifications.alert.error("abrir viaje reporte", errors.response.data);
            });
        }
      );
    },
    finalizarViajeReparto() {
      let self = this;
      Notifications.alert.confirm(
        "Finalizar viaje reparto",
        "¿Seguro(a)?",
        "Si",
        function () {
          DynamicService.postAction(
            "cat",
            "viajes-reparto",
            self.current.id,
            "finalizar_viaje_reparto"
          )
            .then(
              self.refreshCurrent(),
              Notifications.alert.success(
                "Finalizar Viaje Reparto",
                "Realizado Exitosamente"
              )
            )
            .catch((errors) => {
              Notifications.alert.error("Finalizar viaje reporte", errors.response.data);
            });
        }
      );
    },
    anularViajeReparto() {
      let self = this;
      Notifications.alert.confirm(
        "Anular viaje reparto",
        "¿Seguro(a)?",
        "Si",
        function () {
          DynamicService.postAction(
            "cat",
            "viajes-reparto",
            self.current.id,
            "anular_viaje_reparto"
          )
            .then(
              self.refreshCurrent(),
              Notifications.alert.success(
                "Anular Viaje Reparto",
                "Realizado Exitosamente"
              )
            )
            .catch((errors) => {
              Notifications.alert.error("Anular viaje reporte", errors.response.data);
            });
        }
      );
    },
    asignarPedidoViaje() {
      DynamicService.postAction(
        "cat",
        "viajes-reparto",
        this.current.id,
        "asignar_pedido_viaje",
        this.currenDetalle
      )
        .then((responde) => {
          Notifications.alert.success("Asignar pedido a viaje", "Realizado Exitosamente");
          $("#modalAsignarPedido").modal("hide");
          this.refreshCurrent();
          this.cleanData()
        })
        .catch((errors) => {
          $("#modalAsignarPedido").modal("hide");
          this.cleanData()
          Notifications.alert.error(
            "Asignar pedido a viaje",
            errors.response.data.detail
          );
        });
    },
    cleanData() {
      this.currenDetalle.barra = ""
    },
    abrirModalAsignarPedido() {
      $("#modalAsignarPedido").modal("show");
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("cat", "viajes-reparto", self.current.id).then(
        (response) => {
          self.current = response.data;
          self.current.usuario = self.current.encargado_obj;
          self.current.fecha_creacion = moment(self.current.fecha_creacion).format(
            "DD/MM/YYYY"
          );
          if (self.current.vehiculo_obj) {
            self.current.vehiculo = self.current.vehiculo_obj;
          }
          if (self.current.fecha_retorno) {
            self.current.fecha_retorno = moment(self.current.fecha_retorno).format(
              "DD/MM/YYYY"
            );
          }
          if (self.current.fecha_salida) {
            self.current.fecha_salida = moment(self.current.fecha_salida).format(
              "DD/MM/YYYY"
            );
          }
          if (self.current.piloto_obj) {
            self.current.piloto = self.current.piloto_obj;
          }
        }
      );
    },
    imprimirDetalle(current) {
      let self = this;
      self.id = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/viajes/viaje_reparto_detalle.jrxml&id=${self.id}`
      );
    },
    imprimir(current) {
      let self = this;
      self.id = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/viajes/viaje_reparto.jrxml&id=${self.id}`
      );
    },
    guardar() {
      let self = this;
      var current = Object.assign({}, this.current);
      if (current.id == null) {
        delete current.id;
      }
      if (current.piloto) {
        current.piloto = current.piloto.id;
      }
      if (current.vehiculo) {
        current.vehiculo = current.vehiculo.id;
      }
      if (self.current.usuario) {
        current.encargado = self.current.usuario.id;
      }
      DynamicService.save("cat", "viajes-reparto", current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Viaje reparto",
            "Se ha Modificado la Información."
          );
          self.refreshCurrent();
        })
        .catch((error) => {
          if (error.response) {
            self.current.errors = error.response.data;
          }
        });
    },
    showModal(e) {
      e.preventDefault();
    },
    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "tarima",
        "¿Esta seguro de eliminar la tarima del contenedor",
        "Si Eliminar",
        function () {
          ContenedorService.remover_tarima_a_contenedor(self.current.id, {
            tarima_barra: detalle.barra,
          })
            .then((response) => {
              Notifications.alert.success("tarima", "Se ha eliminado la Información.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Vue.nextTick(function () {
                if ("detail" in error.response.data) {
                  Notifications.alert.error("Error", error.response.data.detail);
                }
              });
            });
        }
      );
    },
  },
};
</script>
